export default __webpack_public_path__ + "static/media/smart-settings.6686fa1f.svg";